export default {"src":"/_next/static/media/pin.3f7e42fd.svg","height":33,"width":32};